export default {
  testimonials: 'Testimonials',
  institutions: 'Institutions',
  subtitle: 'Institutions leading the digital transformation of higher education together with KeyLearning.',
  location: 'Where to find us',
}
